<div class="impersonalize-user">
  <div class="impersonalize-user__loader" *ngIf="isLoading">
    <app-loading [onlyIcon]="true"></app-loading>
    {{ 'COMMONS.LOADING' | i18nextEager }}
  </div>
  <div class="impersonalize-user__top-header">
    <span class="impersonalize-user__title">{{ 'IMPERSONALIZE.TITLE' | i18nextEager }}</span>
    <span class="impersonalize-user__click" (click)="closeDialog()">
      <img src="/assets/icons/close_modal.svg" alt="" />
    </span>
  </div>
  <div class="impersonalize-user__body">
    <form [formGroup]="impersonalizeForm">
      <mat-form-field appearance="outline">
        <mat-label>{{ 'COMMONS.EMAIL' | i18nextEager }}</mat-label>
        <input matInput formControlName="email" maxlength="50" />
        <mat-error
          *ngIf="
            impersonalizeForm?.controls.email.errors?.required &&
            (impersonalizeForm?.controls.email.touched || impersonalizeForm?.controls.email.dirty)
          "
        >
          {{ 'COMMONS.REQUIRED_FIELD' | i18nextEager }}
        </mat-error>
        <mat-error
          *ngIf="
            impersonalizeForm?.controls.email.errors?.pattern &&
            (impersonalizeForm?.controls.email.touched || impersonalizeForm?.controls.email.dirty)
          "
        >
          {{ 'COMMONS.ERROR_PATTER_EMAIL' | i18nextEager }}
        </mat-error>
        <mat-error
          *ngIf="
            impersonalizeForm?.controls.email.errors?.duplicate_email &&
            (impersonalizeForm?.controls.email.touched || impersonalizeForm?.controls.email.dirty)
          "
        >
          {{ 'COMMONS.DUPLICATE_EMAIL' | i18nextEager }}
        </mat-error>
      </mat-form-field>
    </form>
  </div>
  <div class="impersonalize-user__footer">
    <button [disabled]="impersonalizeForm.invalid" (click)="impersonalize()">
      {{ 'IMPERSONALIZE.TITLE' | i18nextEager }}
    </button>
    <button *ngIf="token" (click)="delete()">
      {{ 'COMMONS.EXIT' | i18nextEager }}
    </button>
  </div>
</div>
